module.exports = __webpack_public_path__ + "img/stripe.7c5dbce9.svg";